import { lazy } from 'react';


export const AboutUs = lazy(() => import('./AboutUs'));
